import React from 'react';
import { useController } from 'react-hook-form';
import { FormControl, FormHelperText, FormLabel, TextField } from '@mui/material';
import { t } from 'i18next';

function CustomTextField({
  name,
  type = 'text',
  dir = 'rtl',
  label,
  control,
  InputProps,
  InputLabelProps,
  onChangeInterceptor,
  showDefaultErrorMessage = true,
  rules,
  labelType = 'shrink',
  ...props
}) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
  });
  return (
    <FormControl fullWidth error={!!error}>
      {label && labelType === 'noShrink' && (
        <FormLabel>{`${label} ${rules?.required ? '*' : ''}`}</FormLabel>
      )}
      <TextField
        {...field}
        value={field.value}
        onChange={(e) => {
          field.onChange(e);
          if (onChangeInterceptor) {
            field.onChange(onChangeInterceptor(e.target.value));
          } else {
            field.onChange(e.target.value);
          }
        }}
        onBlur={(event) => {
          if (typeof event.target.value === 'string' && /^\s+|\s+$/g.test(event.target.value)) {
            event.target.value = event.target.value.trim();
            field.onChange(event);
          }
          if (onChangeInterceptor) {
            event.target.value = onChangeInterceptor(event.target.value);
          }
          field.onBlur();
        }}
        label={
          label && labelType === 'shrink' ? `${label} ${rules?.required ? '*' : ''}` : undefined
        }
        type={type}
        error={!!error}
        helperText={error?.message}
        variant="outlined"
        fullWidth
        InputProps={{ dir, color: 'primary', ...InputProps }}
        InputLabelProps={{ color: 'primary', ...InputLabelProps }}
        {...props}
      />
      <FormHelperText>
        {error?.message ||
          (showDefaultErrorMessage && error && t('فیلد {{label}} اجباری می‌باشد', { label }))}
      </FormHelperText>
    </FormControl>
  );
}

export default React.memo(CustomTextField);
